import { useIsWisdomHomeV2Enabled } from '@modules/oracle/hooks';
import { OracleEmptySearchViewV1 } from './OracleEmptySearchViewV1';
import { OracleEmptySearchViewV2 } from './OracleEmptySearchViewV2';

export function OracleEmptySearchView() {
  const isWisdomHomeV2Enabled = useIsWisdomHomeV2Enabled();

  if (isWisdomHomeV2Enabled) {
    return <OracleEmptySearchViewV2 />;
  }

  return <OracleEmptySearchViewV1 />;
}
